module.exports = __webpack_public_path__ + "img/pictoPeople4.8559ae7c.svg";